import React from 'react';

// Placeholder Icon component - replace with actual icons (e.g., Font Awesome)
const IconPlaceholder = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg>
);

const Benefits = () => {
  const benefitsList = [
    {
      icon: <IconPlaceholder className="w-8 h-8 text-primary" />,
      title: "Instant Answers 24/7",
      description: "Uses your spreadsheets (products, services, pricing) to provide info instantly, any time.",
    },
    {
      icon: <IconPlaceholder className="w-8 h-8 text-primary" />,
      title: "Automatic Lead Capture",
      description: "Intelligently asks for name/email/phone when a potential lead is identified.",
    },
    {
      icon: <IconPlaceholder className="w-8 h-8 text-primary" />,
      title: "Immediate Team Notifications",
      description: "Alerts your sales or support team instantly via email/SMS for follow-up.",
    },
    {
        icon: <IconPlaceholder className="w-8 h-8 text-primary" />,
        title: "Boost Conversions",
        description: "Engage website visitors who dislike contact forms or waiting for responses.",
      },
  ];

  return (
    <section className="bg-background dark:bg-gray-800 py-12 lg:py-20">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-text-primary dark:text-white mb-12">
          Why Wizbang Works
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefitsList.map((benefit, index) => (
            <div key={index} className="text-center p-6 bg-white dark:bg-gray-700 rounded-lg shadow-md">
              <div className="flex justify-center mb-4">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold text-text-primary dark:text-white mb-2">
                {benefit.title}
              </h3>
              <p className="text-text-secondary dark:text-gray-300">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits; 